<template>
    <iframe
        v-if="docIdProps[docId]?.iFrame"
        id="trusted-parts-distributor-stock-search-iframe"
        :src="iFrameSrc"
        class="w-full border-0 h-120 lg:h-180" />
    <div v-else id="trusted-parts-stock-widget-root" v-bind="widgetDataProps"></div>
</template>
<script setup lang="ts">
const config = useRuntimeConfig();

const { cdnUrl, baseUrl } = config.public;

const docIdProps: Record<string, { iFrame: boolean; partNumber?: string }> = {
    "sample-iframe-with-search": { iFrame: true },
    "sample-iframe-without-search": { iFrame: true, partNumber: "DMB-4772" },
    "sample-embedded-with-search": { iFrame: false },
    "sample-embedded-without-search": { iFrame: false, partNumber: "CU-1933-MB" },
};

const { docId } = defineProps<{ docId: string }>();

onMounted(() => {
    if (!docIdProps[docId]?.iFrame) {
        const loaderUrl = `${cdnUrl}/scripts/ext/dssloader.min.js`;
        useHead({ script: [{ src: loaderUrl }] });
    }
});

const widgetParams = computed(() => {
    const partNumber = docIdProps[docId]?.partNumber;
    const output: Record<string, string> = {
        dssToken: "4ccfddf9-5965-423f-9983-d0cacab6216a",
        countryCode: "US",
        language: "en-US",
        currency: "USD",
        searchType: partNumber !== undefined ? "partial" : "exact",
        manufacturerId: "110",
        showSearch: partNumber == undefined ? "true" : "false",
        showPricing: "true",
        theme: "blue",
    };
    if (partNumber) output.partNumber = partNumber;
    return output;
});

const iFrameSrc = computed(() => {
    const params = new URLSearchParams(widgetParams.value);

    return `${baseUrl}/distributor-stock-search?${params}`;
});

const widgetDataProps = computed(() =>
    Object.fromEntries(
        Object.entries(widgetParams.value).map(([key, value]) => [
            "data-" + key.replace(/([A-Z])/g, "-$1").toLowerCase(),
            value,
        ])
    )
);
</script>
